// Arrival from another site (docs/sites-and-domains.md): a door to a room on another domain loads that domain's page
// with ?from=&spawn=&name=&color=&media=&t= (shared/sites.ts crossSiteUrl). Read once when this module loads, before
// the UI reads the name and colour: they go into this domain's localStorage, and the parameters leave the URL.

import { readArrival, type Arrival } from '@lr3d/shared';

function take(): Arrival | null {
  const { arrival, clean } = readArrival(new URL(location.href));
  if (!arrival) return null;
  try {
    if (arrival.name) localStorage.setItem('lr3d.name', arrival.name);
    if (arrival.color) localStorage.setItem('lr3d.color', arrival.color);
  } catch { /* storage blocked: the UI picks a name */ }
  history.replaceState(history.state, '', clean);
  return arrival;
}

export const arrival: Arrival | null = take();
